import * as React from 'react';
import { Nav, NavItem } from 'react-bootstrap';
import { NavWrapper, NavItemWrapper } from "../styles";


interface IProps {
    activeKey: string,
    centerId: number,
    centerAlias: string,
    onTabSelect: (key: string) => void
}

class RecipientNav extends React.Component<IProps, {}> {
    handleSelect = (e: React.FormEvent<Nav>) => {
        this.props.onTabSelect(e['eventKey']);
    }

    render = () => {
        const hrefView = `center/${this.props.centerId}/recipients`;
        const hrefCheekSwab = '/center/' + this.props.centerId + '/profile/cheek-swab-request';
        const hrefAddRecipient = '/center/' + this.props.centerId + '/donor/add';
        const hrefWaitList = `/center/recipient/${this.props.centerId}/wait-list`;
        const tabWidth = '230';

        return (
            <>
                <NavWrapper verticalAlign='center' minTabWidth='85' fontSize='12px'>
                    <Nav bsStyle='tabs' className='acc-tabs' activeKey={this.props.activeKey}>

                        <NavItemWrapper active={this.props.activeKey == 'RECIPIENT-VIEW'} href={hrefView} tabWidth={tabWidth}>
                            View
                        </NavItemWrapper>

                        <NavItemWrapper active={this.props.activeKey == 'RECIPIENT-CHEEK-SWAB'} href={hrefCheekSwab} tabWidth={tabWidth}>
                            Order Bulk Cheek Swabs
                        </NavItemWrapper>

                        <NavItemWrapper active={this.props.activeKey == 'RECIPIENT-WAIT-LIST'} href={hrefWaitList} tabWidth={tabWidth}>
                            Upload Waitlist
                        </NavItemWrapper>

                        <NavItemWrapper active={this.props.activeKey == 'RECIPIENT-ADD'} href={hrefAddRecipient} tabWidth={tabWidth}>
                            Add
                        </NavItemWrapper>

                    </Nav>
                </NavWrapper>
            </>
        )
    }
}
export default RecipientNav